import "./watchLater.css";
import Movie from "./../../Components/Movie/Movie";
import { useProducts } from "./../../Context/products-context";
import { useEffect } from "react";
import { useToken } from "./../../Context/token-context";

const WatchLater = () => {
  const { state, dispatch } = useProducts();

  const { encodedToken } = useToken();

  useEffect(() => {
    localStorage.setItem("LIKED_ARRAY", JSON.stringify(state.likedArray));
    localStorage.setItem(
      "WATCH_LATER_ARRAY",
      JSON.stringify(state.watchLaterArray)
    );
    localStorage.setItem("HISTORY_ARRAY", JSON.stringify(state.historyArray));
    localStorage.setItem("DISLIKED_ARRAY", JSON.stringify(state.dislikedArray));
  }, [
    state.likedArray,
    state.watchLaterArray,
    state.historyArray,
    state.dislikedArray,
  ]);

  useEffect(() => {
    fetch("/api/user/watchlater", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: encodedToken,
      },
    });
  }, [encodedToken]);

  return (
    <div className="WatchLater">
      {state.watchLaterArray.length > 0 && <h1>Watch later</h1>}
      <div className="watch-later-section">
        {state.watchLaterArray.length === 0 && (
          <h1 className="empty-watch-later">Nothing to Watch Later!</h1>
        )}
        {state.watchLaterArray.length > 0 &&
          state.watchLaterArray.map((movie) => {
            return (
              <Movie
                key={movie.id}
                source={movie.source}
                thumbnail={movie.thumbnail}
                title={movie.title}
                notLikedPage={true}
                addToLiked={() =>
                  dispatch({
                    type: "Add to Liked",
                    payload: { video: movie, token: encodedToken },
                  })
                }
                removeFromLiked={() =>
                  dispatch({
                    type: "Remove from Liked",
                    payload: { video: movie, token: encodedToken },
                  })
                }
                addToWatchLater={() =>
                  dispatch({
                    type: "Add to Watch Later",
                    payload: { video: movie, token: encodedToken },
                  })
                }
                addToHistory={() =>
                  dispatch({
                    type: "Add to History",
                    payload: { video: movie, token: encodedToken },
                  })
                }
                likeButtonColor={
                  state.likedArray.find((element) => element.id === movie.id)
                    ? "var(--binge-red)"
                    : "whitesmoke"
                }
                dislikeButtonColor={
                  state.dislikedArray.find((element) => element.id === movie.id)
                    ? "var(--binge-red)"
                    : "whitesmoke"
                }
                watchLaterButtonColor={
                  state.watchLaterArray.find(
                    (element) => element.id === movie.id
                  )
                    ? "var(--binge-red)"
                    : "whitesmoke"
                }
              />
            );
          })}
      </div>
    </div>
  );
};

export default WatchLater;
